import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios de la consulta de precios vigentes: SOLO LECTURA.
// Backend: `UNICEN/modules/economico`. Contrato completo:
// UNICEN/modules/economico/docs/consulta-precios.openapi.yaml
//
// La sede es siempre la del token (no se manda). Mismas convenciones que el
// resto del módulo: `{ data }`, errores `{ mensaje, campo? }` (leer con `errorDeApi`).
//
//   GET /economico/consulta-precios/opciones
//       -> { id_sede, gestiones, planes, carreras, categorias }
//   GET /economico/consulta-precios/matriz?id_gestion&planes&id_carrera&id_plan_estudio&extranjero&categoria
//       -> { gestion, extranjero, columnas, filas, sin_precio_en_gestion }
//   GET /economico/consulta-precios/costo-credito?id_gestion&id_carrera&id_plan_estudio
//       -> { gestion, filas }
//   GET /economico/consulta-precios/plazos?id_gestion&planes&id_carrera&id_plan_estudio
//       -> { gestion, calendarios, sin_calendario, items_en_cuotas }
//   GET /economico/consulta-precios/resumen?id_gestion&id_plan&id_carrera&id_plan_estudio&extranjero
//       -> { gestion, columna, lineas, total_semestre, contado, falta, costo_credito }

const resource = '/economico/consulta-precios';

/** Los planes viajan como lista separada por comas; los vacíos no se mandan. */
function parametros(filtros = {}) {
  const params = {};
  Object.entries(filtros).forEach(([clave, valor]) => {
    if (valor === null || valor === undefined || valor === '') return;
    if (Array.isArray(valor)) {
      if (valor.length) params[clave] = valor.join(',');
      return;
    }
    params[clave] = valor;
  });
  return params;
}

const useConsultaPreciosApi = {
  opciones() {
    return apiClient.get(`${resource}/opciones`, conToken());
  },

  matriz({
    id_gestion, planes, id_carrera, id_plan_estudio, extranjero, categoria,
  }) {
    return apiClient.get(`${resource}/matriz`, conToken({
      params: parametros({
        id_gestion, planes, id_carrera, id_plan_estudio, extranjero, categoria,
      }),
    }));
  },

  costoCredito({ id_gestion, id_carrera, id_plan_estudio }) {
    return apiClient.get(`${resource}/costo-credito`, conToken({
      params: parametros({ id_gestion, id_carrera, id_plan_estudio }),
    }));
  },

  plazos({
    id_gestion, planes, id_carrera, id_plan_estudio,
  }) {
    return apiClient.get(`${resource}/plazos`, conToken({
      params: parametros({
        id_gestion, planes, id_carrera, id_plan_estudio,
      }),
    }));
  },

  resumen({
    id_gestion, id_plan, id_carrera, id_plan_estudio, extranjero,
  }) {
    return apiClient.get(`${resource}/resumen`, conToken({
      params: parametros({
        id_gestion, id_plan, id_carrera, id_plan_estudio, extranjero,
      }),
    }));
  },
};

export default useConsultaPreciosApi;
